<template>
  <div class="w-full h-full flex-col min-h-[250px]">
    <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute rounded-t-lg left-0 top-0 pointer-events-none" />
    <div class="flex items-center w-full">
      <PanelBottomDashed class="w-12 h-12" color="#000" />
      <span class="mt-1 ml-2 text-3xl font-bold text-black">{{ $t("Share Progress to Team member") }}</span>
      <div
        class="w-8 h-8 ml-auto mr-3 bg-white border rounded-full cursor-pointer has-tooltip dark:border-dark-divider-border dark:bg-dark-screen-background"
        @click="$emit('cancel')">
        <X color="#FF0000" class="w-6 h-6 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" /><span
          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
          {{ $t("Close") }}</span>
      </div>
    </div>
    <div class="text-common-grey">
      {{ $t("Let your team members know that the status changed for this") }} {{ object.otype }}
    </div>

    <div class="mt-12 pt-2">
      <AsyncAutoCompleteInput
        :add="true"
        :add-label="$t('Share with team member')"
        :clear-on-select="true"
        :is-box-background="true"
        :selected-items="selected_users"
        classes="w-full"
        input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm "
        name="users"
        label-attr="full_name"
        search-field="name"
        filter-field="record"
        :endpoint="`/api/organizations/${$store.state.organization.id}/users`"
        type="text"
        :placeholder="$t('Search team member')"
        @chosen="
          ($event) => {
            selected_users.push($event)
          }
        " />
      <div class="min-h-[50px]">
        <div v-for="(user, index) in selected_users" :key="user.id" class="flex items-center mt-3 space-x-2">
          <img v-if="user.avatar" class="inline-block rounded-full h-9 w-9 object-cover" :src="user.avatar" alt="">
          <Avatar v-else
                  :radius="34"
                  :hover-effect="true"
                  :first-name="user.first_name"
                  :last-name="user.last_name" />
          <div>{{ user.full_name }}</div>
          <div @click="selected_users.splice(index, 1)">
            <Trash2 class="w-5 h-5 mr-2 text-gray-300 cursor-pointer" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center flex-row justify-between gap-2 mt-5 text-center">
      <span class="text-[#2DA7D7] hover:cursor-pointer" @click="$emit('cancel')">{{ $t("Cancel") }}</span>
      <div
        class="flex cursor-pointer items-center border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] px-6 font-bold text-white rounded-full w-fit-content h-[50px] content-center text-[14px]"
        @click="share()">
        <ShareTeamMembersIcon class="w-7 h-7 ml-1 mr-3" />
        <span> {{ $t("Invite Team Members") }} </span>
      </div>
    </div>
  </div>
</template>
<script>
import ShareTeamMembersIcon from "@/components/shared/icons/ShareTeamMembersIcon.vue"
import { PanelBottomDashed, Trash2, X } from "lucide-vue-next"
import AsyncAutoCompleteInput from "@/components/shared/AsyncAutoCompleteInput.vue"
import Avatar from "@/components/shared/Avatar.vue"
export default {
  components: {
    AsyncAutoCompleteInput,
    Avatar,
    Trash2,
    PanelBottomDashed,
    ShareTeamMembersIcon,
    X
  },
  props: {
    object: {
      type: Object,
      required: true
    }
  },
  emits: ["done", "cancel"],
  data() {
    return {
      selected_users: []
    }
  },
  methods: {
    share() {}
  }
}
</script>
